import React from "react";
import { useTranslation } from "react-i18next";

import DealerInfoPanel from "~/components/DealerInfoPanel";
import Pagination from "~/components/Pagination";
import { TableV2 } from "~/shared/ui/TableV2";
import { PkdLinks } from "~/widgets/PkdLinks";

import { useChecklistsPage } from "./hooks/useChecklistsPage";
import { getChecklistsColumns } from "./model/tableAdapter";

import s from "./checklists.less";

const Checklists = () => {
  const { t } = useTranslation();
  const { checklists, total, handleViewClick } = useChecklistsPage({
    withAutoCrmidGuard: true,
  });

  return (
    <>
      <div className={s.wrapper}>
        <PkdLinks />
        <div className={s.title}>
          <div className={s.wrappFlex}>
            <span>{t(`pkd_checklists.magazine_checklists`)}</span>
            <DealerInfoPanel type="Staff" />
            {!checklists.length && (
              <div className={s.noData}>{t(`pkd_checklists.no_data`)}</div>
            )}
          </div>
        </div>

        {checklists.length > 0 && (
          <Pagination total={total}>
            <TableV2
              columns={getChecklistsColumns(t)}
              dataSource={checklists}
              rowKey="id"
              onRow={(record) => ({
                onClick: () => handleViewClick(record),
              })}
            />
          </Pagination>
        )}
      </div>
    </>
  );
};

export default Checklists;
